// extracted by mini-css-extract-plugin
export default {"sectionBorder":"style_sectionBorder__A1gUx"};